import { Fragment } from 'react'
import { FormattedMessage } from 'react-intl'

import PackageExtra from './PackageExtra'
import PackageDives from './PackageDives'
import { PriceConverter } from '../../../helpers'
import CoupounItem, { CouponDiscountValue } from './CouponItem'
import { generateGuestsText } from '../../../forms/GuestPicker'

export const PackageExtras = ({
  items,
  isPartial,
  showCourseDetails,
  currency,
  isCoupon,
  onCouponRemove,
}) => {
  return (
    <div className={`${!isPartial ? 'price-pan__body' : 'price-pan__group'}`}>
      {items.map((item) => {
        return isCoupon ? (
          <CoupounItem
            key={item.title}
            item={item}
            onCouponRemove={onCouponRemove}
          />
        ) : (
          <PackageExtra
            key={item.title + item.pk}
            item={item}
            currency={currency}
            isCoupon={isCoupon}
            showCourseDetails={showCourseDetails}
          />
        )
      })}
    </div>
  )
}

export const PackageFooter = ({
  message,
  currency,
  totalPrice = 0,
  isCoupon,
  couponItem,
  showGuests,
  guestsInRoom,
}) => {
  return (
    <div className='price-pan__footer'>
      <div className='title'>
        <strong>
          {message}
          {showGuests && guestsInRoom && (
            <small className='incl'>{generateGuestsText(guestsInRoom)}</small>
          )}
        </strong>
      </div>
      <div className='total-price'>
        {isCoupon ? (
          <CouponDiscountValue item={couponItem} />
        ) : (
          <PriceConverter currency={currency} amount={totalPrice} />
        )}
      </div>
    </div>
  )
}

export const PackageHeader = ({ title, showQuantity, showPrice }) => {
  return (
    <div className='price-pan__header'>
      <div className='title'>{title}</div>
      {showQuantity && (
        <div className='quantity'>
          <FormattedMessage id='quantity' defaultMessage='Quantity' />
        </div>
      )}
      {showPrice && (
        <div className='price'>
          <FormattedMessage id='price' defaultMessage='Price' />
        </div>
      )}
      <div className='total-price'>
        <FormattedMessage id='total_price' defaultMessage='Total price' />
      </div>
    </div>
  )
}

export const PackageInclusionsGroup = ({
  title,
  items,
  showDives,
  order,
  quantity,
  showCourseDetails,
}) => {
  return (
    <Fragment>
      <div className='price-pan__sub-header'>
        <div className='title bold'>{title}</div>
        <div className='quantity'>{quantity}</div>
        <div className='total-price' />
      </div>
      {showDives && order && <PackageDives order={order} />}
      <PackageExtras
        items={items || []}
        isPartial
        showCourseDetails={showCourseDetails}
      />
    </Fragment>
  )
}

export { PackageExtra }
